// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { shippingBillingInformationStyles } from "@steiner/App/Widgets/CheckoutReviewAndSubmit/ShippingBillingInformation";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

shippingBillingInformationStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: auto;
        gap: 16px 20px;
        ${xScreen("lte", "xs")} {
            display: flex;
            flex-direction: column;
        }
    `,
};

shippingBillingInformationStyles.shippingAddress = {
    container: {
        gap: 8,
        css: css`
            grid-area: 1 / 1 / 2 / 2;
            ${xScreen("lt", "sm")} {
                grid-area: 1 / 1 / 2 / 3;
            }
        `,
    },
};

shippingBillingInformationStyles.billingAddress = {
    container: {
        gap: 8,
        css: css`
            grid-area: 1 / 2 / 2 / 3;
            ${xScreen("lt", "sm")} {
                grid-area: 5 / 1 / 6 / 3;
            }
            ${xScreen("lte", "xs")} {
                order: 1;
            }
        `,
    },
};

shippingBillingInformationStyles.styledHr = {
    css: css`
        grid-area: 2 / 1 / 3 / 2;
        ${xScreen("lt", "sm")} {
            grid-area: 2 / 1 / 3 / 3;
        }
    `,
};

shippingBillingInformationStyles.changeShipToAddress = {
    css: css`
        grid-area: 3 / 1 / 4 / 2;
        ${xScreen("lt", "sm")} {
            grid-area: 3 / 1 / 4 / 3;
        }
    `,
};

shippingBillingInformationStyles.actionsContainer = {
    css: css`
        grid-area: 4 / 1 / 5 / 2;
        display: flex;
        flex-direction: column;
        gap: 16px;
        ${xScreen("lt", "sm")} {
            grid-area: 4 / 1 / 5 / 3;
            margin-bottom: 14px;
        }
    `,
};

shippingBillingInformationStyles.orTitle = {
    variant: "h6",
    css: css`
        margin-bottom: 0;
    `,
};

shippingBillingInformationStyles.updateShipButton = {
    variant: "tertiary",
    css: css`
        max-width: 260px;
    `,
};

shippingBillingInformationStyles.actionsButtonContainer = {
    css: css`
        grid-area: 2 / 1 / 2;
        display: flex;
        gap: 16px;
        margin-top: 15px;
        ${xScreen("lt", "sm")} {
            grid-area: 4 / 1 / 5 / 3;
        }
        ${xScreen("lte", "xs")} {
            margin-top: 8px;
            margin-bottom: 15px;
        }
    `,
};

shippingBillingInformationStyles.cancelAddingOneTimeAddressButton = {
    variant: "secondary",
    sizeVariant: "small",
};

shippingBillingInformationStyles.saveAddingOneTimeAddressButton = {
    sizeVariant: "small",
};

shippingBillingInformationStyles.reviewShipToMessage = {
    css: css`
        max-width: calc(50% - 10px);
    `
};